<template>
  <el-dialog title="成绩审核"
             :visible.sync="dialogVisible"
             width="1200px"
             :close-on-click-modal="false"
             @close="handleClose"
             class="audit-dialog"
             top="5vh"
             @open="open()">
    <div class="audit-container">
      <div class="enrollment-section">

        <!-- <div class="screenshot-container">
          <div class="screenshot-title">成绩截图</div>
          <div class="screenshot-wrapper">
            <img v-if="formData.picture_url"
                 :src="formData.picture_url"
                 alt="成绩截图"
                 class="screenshot-img" />
            <div v-else
                 class="screenshot-placeholder">
              <i class="el-icon-picture-outline"></i>
              <p>暂无截图</p>
            </div>
          </div>
        </div> -->
        <div class="screenshot-container">
          <div class="screenshot-title">成绩截图</div>
          <div class="screenshot-wrapper">
            <div v-if="formData.picture_url"
                 class="screenshot-display">
              <!-- <img :src="formData.picture_url"
                   alt="成绩截图"
                   :class="imageOrientationClass"
                   @load="onImageLoad"
                    /> -->
              <el-image :class="imageOrientationClass"
                        :src="formData.picture_url"
                        :preview-src-list="[formData.picture_url]"
                        @load="onImageLoad">
              </el-image>
            </div>
            <div v-else
                 class="screenshot-placeholder">
              <i class="el-icon-picture-outline"></i>
              <p>暂无截图</p>
            </div>
          </div>
        </div>

        <div class="form-section">
          <el-form ref="form"
                   :model="formData"
                   label-width="120px"
                   size="small">
            <el-form-item label="姓名">
              <el-input v-model="formData.user_name"
                        style="width:215px" />
            </el-form-item>
            <el-form-item label="院校"
                          prop="college">
              <el-select v-model="formData.college"
                         filterable
                         placeholder="请选择"
                         @change="collegeChange">
                <el-option v-for="(item, index) in $store.state.collegeList"
                           :key="index"
                           :label="item.name"
                           :value="{ value: item.code, label: item.name }">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="专业"
                          prop="major">
              <el-select v-model="formData.major"
                         placeholder="请选择"
                         filterable
                         clearable
                         @change="majorChange">
                <el-option v-for="(item, index) in majorList"
                           :key="index"
                           :label="`(${item.code})${item.name}`"
                           :value="{ value: item.code, label: item.name }">
                  <span>{{ `(${item.code})${item.name}` }}</span>
                </el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="学院名称："
                          prop="academy">
              <el-select v-model="formData.academy"
                         placeholder="请选择"
                         filterable
                         clearable
                         @change="academyChange">
                <el-option v-for="(item, index) in academylist"
                           :key="index"
                           :label="`(${item.academy_code})${item.academy_name}`"
                           :value="{
                      value: item.academy_code,
                      label: item.academy_name,
                      directions: item.directions,

                    }">
                  <span>{{
                      `(${item.academy_code})${item.academy_name}`
                    }}</span>
                </el-option>
                <!-- directions: item.directions, -->

              </el-select>
            </el-form-item>
            <el-form-item label="方向名称：">
              <el-select v-model="formData.directionObj"
                         placeholder="请选择"
                         filterable
                         clearable
                         @change="directionChange">
                <el-option v-for="(item, index) in directionlist"
                           :key="index"
                           :label="item.direction"
                           :value="{
                      value: item.direction_code,
                      label: item.direction,
                    }">
                  <span>{{
                      `(${item.direction_code})${item.direction}`
                    }}</span>
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="学习方式："
                          prop="enrol_type">
              <el-select v-model="formData.enrol_type"
                         filterable
                         placeholder="请选择"
                         clearable>
                <el-option v-for="(item, index) in enrol_types"
                           :key="index"
                           :label="item.label"
                           :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="科目一成绩">
              <el-input v-model="formData.politics_score"
                        style="width:215px" />
            </el-form-item>
            <el-form-item label="科目二成绩">
              <el-input v-model="formData.language_score"
                        style="width:215px" />
            </el-form-item>
            <el-form-item label="科目三成绩">
              <el-input v-model="formData.profession1_score"
                        style="width:215px" />
            </el-form-item>
            <el-form-item label="科目四成绩">
              <el-input v-model="formData.profession2_socre"
                        style="width:215px" />
            </el-form-item>
            <el-form-item label="总分">
              <el-input v-model="examScoreTotal"
                        style="width:215px"
                        disabled />
            </el-form-item>
            <el-form-item label="状态">
              <el-radio-group v-model="formData.status">
                <el-radio :label="1">通过</el-radio>
                <el-radio :label="2">驳回</el-radio>
              </el-radio-group>
            </el-form-item>

            <el-form-item v-if="formData.status == '2'"
                          label="驳回理由">
              <el-input v-model="formData.refuse_reason"
                        type="textarea"
                        :rows="2"
                        placeholder="请输入驳回理由" />
            </el-form-item>
          </el-form>
        </div>
      </div>
    </div>
    <!-- <div style="position:relative"> -->
    <span slot="footer"
          class="dialog-footer">
      <el-button @click="handleClose">取消</el-button>
      <el-button @click="handleConfirm">确认</el-button>
      <el-button type="primary"
                 @click="handleTo">确认并下一个</el-button>
    </span>
    <div style="position:absolute;bottom:32px;left:20px;"
         class="score-value">{{formData.user_name}} {{examScoreTotal}}分</div>
    <!-- </div> -->

  </el-dialog>
</template>

<script>
import { collegeMajorList, academyList, majorinfo } from '@/api/common'
import { ScoreCheck, getExtendById } from '@/api/rank'
export default {
  name: 'ScoreCheckDialog',
  props: {
    visible: {
      type: Boolean,
      default: false,
    },

    dataForm: {
      type: Object,
      default: () => ({}),
    },
    id_array: {
      type: Array,
      default: () => {
        return []
      },
    },
  },
  data() {
    return {
      p: 0,
      nocheckList: [],
      dialogVisible: false,
      formData: {
        politics_score: null,
        language_score: null,
        profession1_score: null,
        profession2_score: null,
      },
      originalFormData: null,
      majorList: [],
      academylist: [],
      directionlist: [],
      enrol_types: [
        { label: '全日制', value: 1 },
        { label: '非全日制', value: 2 },
      ],
      // 新增：记录图片加载后的方向类别，用于动态class
      imageOrientation: 'landscape', // 'portrait' 或 'landscape'
    }
  },
  computed: {
    examScoreTotal() {
      return (
        (Number(this.formData.politics_score) || 0) +
        (Number(this.formData.language_score) || 0) +
        (Number(this.formData.profession1_score) || 0) +
        (Number(this.formData.profession2_socre) || 0)
      )
    },
    imageOrientationClass() {
      return this.imageOrientation === 'portrait'
        ? 'portrait-img'
        : 'landscape-img'
    },
  },
  watch: {
    visible(val) {
      this.dialogVisible = val
    },
    dataForm(val) {
      this.formData = val
      // this.updateEcho(val)
    },
    id_array(val) {
      this.idArray = val
    },
    examScoreTotal: {
      handler(newVal) {
        this.formData.total_score = newVal
      },
      immediate: true, // 立即执行一次
    },
  },
  methods: {
    open() {
      if (this.$store.state.collegeList) {
        this.$store.dispatch('getAllColleges')
      }
      let data = {
        id: this.formData.id,
      }
      this.detailquest(data)
      setTimeout(() => {
        this.p = this.idArray.map((item) => item).indexOf(this.formData.id)
        this.idArray.splice(this.p, 1)
        this.idArray.unshift(this.formData.id)
      }, 500)
    },

    detailquest(data) {
      this.loading = true
      getExtendById(data).then((res) => {
        this.originalFormData = JSON.parse(JSON.stringify(res))
        this.updateEcho(res)
      })
    },
    //回显数据
    async updateEcho(val) {
      this.fetchMajor(val.college_code)
      this.fetchMajorInfo(val.college_code, val.major_code)
      this.formData = val

      this.$set(this.formData, 'status', 1)
      this.$set(this.formData, 'college', {
        value: val.college_code,
        label: val.college_name,
      })
      this.$set(this.formData, 'major', {
        value: val.major_code,
        label: val.major_name,
      })
      this.$set(this.formData, 'academy', {
        value: val.academy_code,
        label: val.academy_name,
      })

      this.$set(this.formData, 'directionObj', {
        value: val.direction_code,
        label: val.direction,
      })
    },
    // 录取院校选择后还要搜索相对应的院校名称
    collegeChange(e) {
      this.formData.college_code = e.value
      this.formData.college_name = e.label
      this.fetchMajor(e.value)
      this.$forceUpdate()
    },
    fetchMajor(college_code) {
      collegeMajorList({ college_code, isPaging: 0 }).then((res) => {
        this.majorList = res.list
      })
    },

    majorChange(e) {
      this.formData.major_code = e.value
      this.formData.major_name = e.label
      this.fetchMajorInfo(this.formData.college_code, e.value)
      // this.$forceUpdate()
    },
    fetchAcademy(college_code, major_code) {
      academyList({ college_code, major_code, isPaging: 0 }).then((res) => {
        this.academylist = res.list
      })
    },
    fetchMajorInfo(college_code, major_code) {
      majorinfo({ college_code, major_code, isPaging: 0 }).then((res) => {
        this.academylist = res.academys
        const academy = this.academylist.find(
          (item) => item.academy_code === this.formData.academy_code
        )
        if (academy) {
          this.directionlist = academy.directions
        }
      })
    },
    academyChange(e) {
      this.formData.academy_code = e.value
      this.formData.academy_name = e.label
      this.directionlist = e.directions
    },
    directionChange(e) {
      this.formData.direction_code = e.value
      this.formData.direction = e.label
    },

    hasOtherFieldsChanged() {
      const fieldsToCompare = [
        'user_name',

        'college_code',

        'college_name',

        'major_code',

        'major_name',

        'academy_code',

        'academy_name',

        'direction_code',

        'direction',

        'enrol_type',

        'politics_score',

        'language_score',

        'profession1_score',

        'profession2_socre',

        'total_score',
      ]

      for (let field of fieldsToCompare) {
        if (
          field === 'college' ||
          field === 'major' ||
          field === 'academy' ||
          field === 'directionObj'
        ) {
          continue
        }

        if (this.formData[field] !== this.originalFormData[field]) {
          return true
        }
      }
      if (
        this.formData.college?.value !== this.originalFormData.college_code ||
        this.formData.major?.value !== this.originalFormData.major_code ||
        this.formData.academy?.value !== this.originalFormData.academy_code ||
        this.formData.directionObj?.value !==
          this.originalFormData.direction_code
      ) {
        return true
      }

      return false
    },
    handleClose() {
      this.dialogVisible = false
      this.$emit('close')
    },

    handleConfirm() {
      if (!this.formData.status) {
        this.$message.error('请选择状态')

        return
      }
      if (this.formData.id) {
        let obj = {
          score_id: this.idArray[0],
          check_status: this.formData.status,
          refuse_reason: this.formData.refuse_reason,
        }
        if (this.hasOtherFieldsChanged()) {
          obj.access_update_obj = this.formData
        }
        ScoreCheck(obj).then((res) => {
          this.$message.success(`审核通过`)
          this.$emit('confirm')
        })
      } else {
        console.log('无id')
      }
    },
    // 通过并继续
    handleTo() {
      if (this.idArray.length == 1) {
        this.handleConfirm()
        this.$message.success(`暂时待审核没有数据了`)
        return
      } else {
        let obj = {
          score_id: this.idArray[0],
          check_status: this.formData.status,
          refuse_reason: this.formData.refuse_reason,
          access_update_obj: this.formData,
        }
        if (this.hasOtherFieldsChanged()) {
          obj.access_update_obj = this.formData
        }
        ScoreCheck(obj).then((res) => {
          this.$message.success(`审核通过请继续下一条`)
          this.idArray.splice(0, 1)
          this.detailquest({
            id: this.idArray[0],
          })
        })
      }
    },
    onImageLoad(e) {
      const img = e.target
      // 自然宽高比 > 1 为横向长图（宽>高），否则为竖向长图
      const isPortrait = img.naturalHeight > img.naturalWidth
      this.imageOrientation = isPortrait ? 'portrait' : 'landscape'
    },
  },
}
</script>

<style scoped>
.score-value {
  width: 66%;
  display: flex;
  justify-content: center;
  font-size: 32px;
  font-weight: 700;
  letter-spacing: 1px;
}
.audit-dialog /deep/ .el-dialog {
  margin-top: 2vh !important;
  height: 95vh; /* 设置高度为视口的95% */
  display: flex;
  flex-direction: column;
}
.audit-dialog /deep/ .el-dialog__body {
  flex: 1;
  padding: 20px;
  overflow: hidden; /* 防止body出现滚动条 */
  height: calc(96vh - 120px); /* 减去header和footer */
}
.audit-container {
  display: flex;
  gap: 20px;
  height: 100%;
  /* height: 600px; */
}

/* 报录审核样式 */
.enrollment-section {
  display: flex;
  gap: 20px;
  width: 100%;
  height: 100%;
}

/* 成绩审核样式 */
.score-section {
  display: flex;
  gap: 20px;
  width: 100%;
}

/* .screenshot-container {
  flex: 0 0 300px;
  display: flex;
  flex-direction: column;
} */

.screenshot-container {
  height: 100%;
  flex: 2;
  display: flex;
  flex-direction: column;
  min-width: 0;
}

.screenshot-title {
  font-weight: bold;
  margin-bottom: 10px;
  color: #333;
}

/* .screenshot-wrapper {
  flex: 1;
  border: 1px solid #e6e6e6;
  border-radius: 4px;
  overflow: hidden;
  background: #f5f5f5;
  display: flex;
  align-items: center;
  justify-content: center;
} */
.screenshot-wrapper {
  flex: 1;
  border: 1px solid #e6e6e6;
  border-radius: 4px;
  overflow: hidden; /* 隐藏超出部分，避免破坏边界 */
  background: #f5f5f5;
  /* 移除 display:flex / align-items:center, 改用块级容器 + 定位方式实现居中与完整展示 */
  position: relative;
  min-height: 0; /* 重要: 让flex子项正确收缩 */
}
.screenshot-display {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #f5f5f5;
}

/* 横向长图 (宽>高)：宽度撑满，高度自适应，保持比例，居中显示 */
.landscape-img {
  max-width: 100%;
  max-height: 100%;
  width: auto;
  height: auto;
  object-fit: contain; /* 保持比例，完整显示在容器内 */
  display: block;
}

/* 竖向长图 (高>宽)：高度撑满，宽度自适应，保持比例，居中显示 */
.portrait-img {
  max-width: 100%;
  max-height: 100%;
  width: auto;
  height: 100%; /* 高度撑满 */
  object-fit: contain; /* 同样使用 contain 保证完整可见，并居中 */
  display: block;
}
/* 确保el-image也能正确应用样式 */
.portrait-img /deep/ .el-image__inner,
.landscape-img /deep/ .el-image__inner {
  object-fit: contain !important;
}

.screenshot-img {
  /* max-width: 100%;
  max-height: 100%; */
  width: auto;
  height: 100%;
  object-fit: contain;
}

/* .screenshot-placeholder {
  text-align: center;
  color: #999;
  padding: 40px;
} */
.screenshot-placeholder {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  color: #999;
}

.screenshot-placeholder i {
  font-size: 48px;
  margin-bottom: 10px;
}

/* 报录表单 */
.form-section {
  flex: 1;
  overflow-y: auto;
  padding-right: 10px;
  min-width: 0; /* 防止flex溢出 */
}

.form-section .el-form-item {
  margin-bottom: 16px;
}

/* 成绩表单 */
.score-form-section {
  flex: 1;
  display: flex;
  flex-direction: column;
}

.score-header {
  margin-bottom: 15px;
  padding: 8px 0;
  font-weight: bold;
  border-bottom: 1px solid #e6e6e6;
}

.score-list {
  flex: 1;
  overflow-y: auto;
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  gap: 12px;
  padding-right: 10px;
}

.score-item {
  display: flex;
  align-items: center;
  gap: 8px;
}

.score-label {
  width: 70px;
  text-align: right;
  font-size: 12px;
  color: #666;
}

/* 滚动条样式 */
.form-section::-webkit-scrollbar,
.score-list::-webkit-scrollbar {
  width: 6px;
}

.form-section::-webkit-scrollbar-track,
.score-list::-webkit-scrollbar-track {
  background: #f1f1f1;
}

.form-section::-webkit-scrollbar-thumb,
.score-list::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 3px;
}

.form-section::-webkit-scrollbar-thumb:hover,
.score-list::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}

.dialog-footer {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
}
</style>